import React from "react";
import DocumentViewer from "../components/DocumentViewer";
import { useMarkdownContent } from "../hooks/useMarkdownContent";

const BuyerProtectionPolicyPage: React.FC = () => {
  const { content, loading, error } = useMarkdownContent(
    "buyer-protection-policy.md"
  );

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-2 text-gray-600">
            Loading Buyer Protection Policy...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center text-red-600">
          <p>Error loading Buyer Protection Policy: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <DocumentViewer
      content={content}
      title="Buyer Protection Policy"
      filename="baakas-buyer-protection-policy"
    />
  );
};

export default BuyerProtectionPolicyPage;
